import { toLoginPage } from '@/feature/account/services/account.routing'
import { twMerge } from '@/lib/classname/twMerge'
import { useTranslation } from '@/lib/i18n/useTranslation.client'

import { Link } from '@/ui/links/link/Link.client'

type ProductPriceLoginLinkProps = {
  className?: string
  mode?: 'short' | 'detailed'
  isPublicPriceEnabled?: boolean
  hasNationalDiscount?: boolean
  origin?: 'product-buybox' | 'product-card' | 'references-product-table'
}

export function ProductPriceLoginLink({
  className,
  mode = 'short',
  isPublicPriceEnabled,
  hasNationalDiscount,
  origin,
}: ProductPriceLoginLinkProps): React.ReactElement {
  const { t } = useTranslation(['productPriceLoginLink'])

  const trackingDataAction = hasNationalDiscount
    ? 'clic prix publics promotion nationale'
    : isPublicPriceEnabled
      ? 'clic prix publics activés'
      : 'clic prix publics désactivés'

  const baseTrackingData = {
    event: 'gaEvent',
    eventLabel: 'cta prix perso connectez-vous',
  } as const

  const trackingDataByOrigin = {
    'product-card': {
      ...baseTrackingData,
      eventCategory: 'plot produit',
      eventAction: trackingDataAction,
    },
    'product-buybox': {
      ...baseTrackingData,
      eventCategory: 'fiche article / produit',
      eventAction: 'buy box',
    },
    'references-product-table': {
      ...baseTrackingData,
      eventCategory: 'fiche article / produit',
      eventAction: 'tableau de référence',
    },
  } as const

  const trackingData = origin ? trackingDataByOrigin[origin] : undefined

  return (
    <Link
      variant="free"
      className={twMerge(className, 'leading-light')}
      href={toLoginPage()}
      tint="brand-1"
      underlined="invert"
      bold
      trackingData={trackingData}
    >
      {t(`productPriceLoginLink:ctaLogin.${mode}`)}
    </Link>
  )
}
